<template>
    <transition name="el-fade-in" mode="out-in">
        <div class="content-box-alltest">
            <div class="top-title">
                <img src="@/assets/img/grammarTest/book.png" alt="">
                <span>{{dataSource.edition}}</span>
                <span>（题量：{{total}}）</span>
            </div>
            <div class="statistics-box">
                <div>
                    <div class="num">
                        <img src="@/assets/img/test/right_icon.png" alt="">
                        <span>{{correctNum}}</span>
                    </div>
                    <div class="num">
                        <img src="@/assets/img/test/error_icon.png" alt="">
                        <span>{{wrongNum}}</span>
                    </div>
                </div>
                <!-- <div>
                    <span>{{timerText}}</span>
                </div> -->
            </div>
            <div class="progress">
                <el-progress :text-inside="true" :stroke-width="10" :percentage="percentage" :color="customColor"
                             :show-text="false"></el-progress>
            </div>
            <div class="word-title">当前第<span style="color:#F07949">{{num}}</span>个单词</div>
            <!--选择题部分-->
            <div class="select-cont" v-if="questionData.type==1 || questionData.type == 2 || questionData.type == 3">
                <div class="word" v-if="questionData.type == 1 || questionData.type == 2 ">{{question}}</div>
                <div class="voice-box" v-if="questionData.type == 3">
                    <img class="voice-img" :src="GLOBAL.Images.icon_voice" @click="playVoice">
                    <audio ref="voice" :src="questionData.voice" autoplay></audio>
                </div>
                <div class="select-box">
                    <div class="select-item td-fbc" v-for="(item,index) in answers" :key="index"
                         @click="reply(item.id)">
                        <div>
                            <span>{{letter[index]}}</span>
                            <span>{{item.text}}</span>
                        </div>
                        <img v-if="showAnswer&&answer == item.id&&answer == questionData.answer"
                             :src="GLOBAL.Images.icon_test_true">
                        <img v-if="showAnswer&&answer == item.id&&answer != questionData.answer"
                             :src="GLOBAL.Images.icon_test_false">
                        <img v-if="showAnswer&&answer != item.id&&item.id == questionData.answer"
                             :src="GLOBAL.Images.icon_test_true">
                    </div>
                </div>
                <div class="select-hint">请点击本单词正确意义栏</div>
            </div>
            <!--听写部分-->
            <div class="select-box" v-if="questionData.type == 4">
                <div class="exercise-box spell-box">
                    <div class="translate">
                        <el-button type="success" v-if="!showTranslate" @click="showTranslate=!showTranslate">词义提示
                        </el-button>
                        <el-button type="success" v-else @click="showTranslate=!showTranslate">词义隐藏</el-button>
                        <transition name="el-zoom-in-left">
                            <div v-if="showTranslate" class="translate-text">{{questionData.meaning}}</div>
                        </transition>
                    </div>
                    <div class="input-box td-fbc">
                        <!--输入框左侧语音按钮-->
                        <div class="audio-box">
                            <img class="voice-img" :src="GLOBAL.Images.icon_voice" @click="playVoice">
                            <audio ref="voice" :src="questionData.voice" autoplay></audio>
                        </div>
                        <el-input class="td-f1" v-model="spellInput" placeholder=""></el-input>
                        <div class="input-btn">
                            <el-button v-if="!showAnswer" type="success" @click="replySpell">确定</el-button>
                            <span class="result-btn td-fcc" v-if="showAnswer&&answer == questionData.answer">✔</span>
                            <span class="result-btn td-fcc fail"
                                  v-if="showAnswer&&answer != questionData.answer">✘</span>
                        </div>
                    </div>
                    <transition name="el-fade-in" mode="out-in">
                        <div class="error">
                            <span v-show="showAnswer&&answer != questionData.answer">{{questionData.answer}}</span>
                        </div>
                    </transition>
                </div>
            </div>
            <div class="push-btn">
                <el-button type="success" @click="SaveTest">提前交卷</el-button>
                <div style="width: 80px"></div>
                <el-button type="danger" @click="SaveTest">退出测试</el-button>
            </div>
        </div>
    </transition>
</template>

<script>
    import Lockr from "lockr";
    import {wordGetTest, wordSaveTest, wordSaveSubject} from '@/api/words'
    import resultBoard from "@/views/words/wordExam/resultBoard";

    export default {
        name: "test",
        props: {
            dataSource: {}
        },
        data() {
            return {
                total: this.dataSource.total,
                activeNum: '',
                timerSecond: this.dataSource.time,//试卷总时长
                timer: '',
                timerText: '00:00:00',
                num: 1,
                questionData: {},
                question: '',
                answers: [],
                answer: '',
                correctNum: 0,
                wrongNum: 0,
                letter: ['A', 'B', 'C', 'D'],
                showAnswer: false, // 显示答案
                startTime: '',
                showTranslate: false, //是否显示词义提示
                spellInput: "", //单词输入框

                percentage: 0,
                customColor: "#409eff",
                isHint: true, //是否显示强制复习提示语
                showExercise: true, //是否显示练习框
                showHint: false, //是否显示答案
                isError: false, //是否拼写错误
                isCorrect: false, //是否拼写正确

                isNext: true, //控制'下一个'按钮的显示
                showResult: false, //显示结果
                testReport: false //是否显示学习报告
            };
        },
        methods: {
            // 获取题目
            async getQuestion(num = 1) {
                this.num = num
                let params = {
                    token: Lockr.get('token'),
                    total: this.dataSource.total,
                    num: num
                }
                let result = await wordGetTest(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.showAnswer = false
                    this.spellInput = ''
                    this.questionData = result.data.subject
                    this.activeNum = result.data.num

                    let answerArr = []
                    answerArr.push({
                        id: 1,
                        text: this.questionData.option_one,
                    })
                    answerArr.push({
                        id: 2,
                        text: this.questionData.option_two,
                    })
                    answerArr.push({
                        id: 3,
                        text: this.questionData.option_three,
                    })
                    answerArr.push({
                        id: 4,
                        text: this.questionData.option_four,
                    })
                    this.answers = answerArr
                    this.question = this.questionData.subject
                    this.startTime = this.timerSecond
                    // if (!this.timer) {
                    //     this.timerManage()
                    // }
                    setTimeout(() => {
                        // this.playVoice()
                    }, 100)
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            // 提交题目
            async SaveQuestion() {
                console.log(this.timerSecond,'总时长');
                console.log(this.startTime,'开始时间');
                let params = {
                    token: Lockr.get('token'),
                    word_id: this.questionData.word_id,
                    total: this.total,
                    num: this.num,
                    type: this.questionData.type,
                    test_state: this.answer == this.questionData.answer ? 1 : 2,
                    use_time: Math.abs(this.timerSecond - this.startTime),
                }
                let result = await wordSaveSubject(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.correctNum = result.data.complete
                    this.wrongNum = result.data.un_complete
                    this.percentage = result.data.progress
                    if (result.data.is_complete == 1) {
                        // 测试结束
                        this.SaveTest()
                    } else {
                        this.getQuestion(result.data.num)
                    }
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            // 交卷
            async SaveTest() {
                // if (this.total * 0.5 >= this.activeNum) {
                //     this.$message({
                //         message: '题目做的太少啦，再多做一点吧',
                //         type: 'warning'
                //     });
                //     this.disabledClick =false
                //     return
                // }
                let params = {
                    token: Lockr.get('token'),
                    edition_id: this.dataSource.edition_id,
                    test_time: Math.abs(this.dataSource.time - this.timerSecond),
                    count: this.total,
                }
                let result = await wordSaveTest(params)
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    let data = result.data
                    this.DialogResult({
                        title: '一测到底测试结果',
                        component: resultBoard,
                        data: {
                            source: data
                        }
                    })
                    this.close()
                } else {
                    this.$message({
                        message: result.msg,
                        type: 'warning'
                    });
                }
            },
            // 作答
            reply(id) {
                if (this.showAnswer) {
                    return null
                }
                this.answer = id
                this.showAnswer = true
                setTimeout(() => {
                    this.SaveQuestion()
                }, 1000)
            },
            replySpell() {
                if (this.showAnswer) {
                    return null
                }
                this.answer = this.spellInput
                this.showAnswer = true
                setTimeout(() => {
                    this.SaveQuestion()
                }, 1000)
            },
            // 倒计时管理
            timerManage() {
                this.timer = setInterval(() => {
                    this.timerSecond--
                    this.timerText = this.formatTimerHMS(this.timerSecond)
                    if (this.timerSecond < 1) {
                        clearInterval(this.timer)
                        this.SaveTest()
                    }
                }, 1000)
            },
            formatBit(val) {
                val = +val
                return val > 9 ? val : '0' + val
            },
            // 秒转时分秒
            formatTimerHMS(time) {
                let min = Math.floor(time % 3600)
                let val = this.formatBit(Math.floor(time / 3600)) + ':' + this.formatBit(Math.floor(min / 60)) + ':' + this.formatBit(time % 60)
                return val
            },
            // 播放语音
            playVoice() {
                let audio = this.$refs.voice
                if (audio.paused) {
                    // 暂停中
                    audio.play();
                    this.bgMusicPaused = true;
                } else {
                    // 播放中
                    audio.pause();
                    this.bgMusicPaused = false;
                }
            },
            // 关闭弹窗
            close() {
                this.$parent.close();
            }
        },
        created() {
            this.getQuestion()
            console.log(this.dataSource,'回复好地方');
        }
    };
</script>

<style scoped lang='less'>
    .shade {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgb(0, 0, 0);
        opacity: 0.2;
        position: fixed;
        pointer-events: auto;
    }

    .content-box-alltest {
        transition: all 0.5s;
        position: relative;
        width: 90%;
        margin: 0 auto;

        .top-title {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            color: #333;

            img {
                width: 26px;
                height: 26px;
                margin-right: 10px;
            }

            > span:nth-of-type(2) {
                font-size: 18px;
            }
        }

        .statistics-box {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

            > div:nth-of-type(1) {
                display: flex;

                > .num {
                    display: flex;
                    align-items: center;
                    margin: 0 10px;
                    font-size: 20px;
                    font-weight: bold;

                    img {
                        width: 30px;
                        height: 30px;
                        margin-right: 10px;
                    }
                }
            }

            > div:nth-of-type(2) {
                color: #ff5100;
                font-size: 20px;
            }
        }

        .word-title {
            font-size: 16px;
            text-align: center;
            margin-top: 10px;

            > span {
                font-size: 20px;
                padding: 0 10px;
            }
        }

        .word {
            font-size: 32px;
            text-align: center;
            color: #e50114;
            margin-top: 10px;
        }

        .voice-box {
            margin: 20px 0;

            img {
                width: 40px;
                height: 40px;
                object-fit: contain;
                display: block;
            }
        }

        .select-box {
            .select-item {
                height: 40px;
                border-radius: 4px;
                border: 1px solid rgba(151, 151, 151, 1);
                display: flex;
                align-items: center;
                padding: 0 20px;
                cursor: pointer;
                transition: all 0.5s;
                position: relative;
                margin: 12px 0;
                font-size: 16px;

                span {
                    margin-right: 15px;
                    font-weight: bold;
                }

                img {
                    display: block;
                    object-fit: contain;
                    width: 30px;
                    height: 30px;
                }
            }

            .select-item:hover {
                background: #ebeef5;
                border: 1px solid #2bc5ba;
            }
        }

        .select-hint {
            color: #416489;
            font-size: 14px;
            text-align: center;
            margin-top: 20px;
        }

        .spell-box {
            padding-top: 10px !important;

            .translate {
                display: flex;
                align-items: center;
                margin-bottom: 30px;

                .translate-text {
                    font-size: 18px;
                    font-weight: 600;
                    margin-left: 30px;
                }
            }

            .input-box {
                .voice-img {
                    width: 36px;
                    height: 36px;
                    display: block;
                    margin-right: 20px;
                }

                .input-btn {
                    margin: 0 20px;
                    cursor: pointer;
                    transition: all 0.5s;

                    .result-btn {
                        color: #2BC3B9;
                        font-size: 30px;
                    }

                    .result-btn.fail {
                        color: #F56C6C;
                        font-size: 30px;
                    }
                }

                .audio-btn:hover {
                    opacity: 0.7;
                }
            }

            .error {
                padding-left: 70px;
                height: 80px;

                span {
                    color: #e50114;
                    font-size: 28px;
                    font-weight: 600;
                    line-height: 40px;
                }
            }
        }

        .result-box {
            border: none !important;
            overflow-y: auto !important;
            display: flex;
            align-items: center;
            flex-direction: column;

            .result-title {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 26px;
                margin: 20px 0;

                > div:nth-of-type(2) {
                    font-size: 20px;
                }

                img {
                    width: 40px;
                }
            }

            .result-info-1 {
                display: flex;
                justify-content: center;
                margin-bottom: 50px;

                > div {
                    margin: 0 15px;
                    font-size: 24px;
                }
            }

            .result-info-2 {
                font-size: 30px;
            }

            .hint-box {
                display: flex;
                flex-direction: column;
                align-items: center;

                > div {
                    display: flex;
                    width: 300px;
                    margin: 20px 0;

                    > div:nth-of-type(1) {
                        width: 50px;
                        height: 50px;
                        background: #fff;
                        border: 2px solid #00598d;
                        margin-right: 10px;
                    }

                    > div:nth-of-type(2) {
                        height: 54px;
                        font-size: 54px;
                        font-weight: bold;
                        color: #47c149;
                        line-height: 65px;
                    }
                }

                > div:nth-of-type(2) {
                    > div:nth-of-type(2) {
                        color: #ff5100;
                    }
                }
            }

            .pop-btn {
                margin: 20px 0;
            }
        }

        .push-btn {
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }
    }

</style>